import React from 'react';
import { Alert, Tabs, Typography } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';

import AssessmentWorkspace from './AssessmentWorkspace';
import InspectAssessment from './InspectAssessment';
import OperationsQueue from './OperationsQueue';
import ScenarioCatalog from './ScenarioCatalog';
import './styles.css';

const AssessmentManagement: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const selectedCode = new URLSearchParams(location.search).get('scenario');

  const openScenario = (code: string) => {
    history.push(`/dashboard/assessments?scenario=${encodeURIComponent(code)}`);
  };

  const closeScenario = () => history.push('/dashboard/assessments');

  if (selectedCode) {
    return (
      <AssessmentWorkspace
        key={selectedCode}
        code={selectedCode}
        onBack={closeScenario}
        onOpen={openScenario}
      />
    );
  }

  return (
    <div className="assessment-admin">
      <Typography.Title level={2}>Assessment management</Typography.Title>
      <Alert
        className="assessment-callout"
        showIcon
        type="info"
        title="Administration for the answer keys and the sessions they grade"
        description="This workspace manages each answer key's stored definition and inspects what the runtime produced. It does not add a second grading engine, alter capture or scoring, or silently select a blueprint version: an answer key is derived, audited and published from its blueprint page. Blueprint provenance is shown only where a graded session has an exact launch record."
      />
      <Tabs
        items={[
          {
            key: 'models',
            label: 'Answer keys',
            children: <ScenarioCatalog onOpen={openScenario} />,
          },
          {
            key: 'queue',
            label: 'Operations queue',
            children: <OperationsQueue onOpenScenario={openScenario} />,
          },
        ]}
      />
    </div>
  );
};

const AssessmentsAdmin: React.FC = () => (
  <Tabs
    defaultActiveKey="inspect-assessment"
    items={[
      {
        key: 'assessment-management',
        label: 'Assessment management',
        children: <AssessmentManagement />,
      },
      {
        key: 'inspect-assessment',
        label: 'Inspect Assessment',
        children: <InspectAssessment />,
      },
    ]}
  />
);

export default AssessmentsAdmin;
